import { Alert } from 'react-bootstrap'

const Message = ({ variant, children }) => {
  const readableMessage =
    typeof children === 'object' && children !== null
      ? children?.data?.message ||
        children?.error ||
        children?.message ||
        `Request failed${children?.status ? ` (${children.status})` : ''}`
      : children

  return (
    <Alert variant={variant} className="shopwave-alert">
      {readableMessage}
    </Alert>
  )
}

Message.defaultProps = {
  variant: 'info',
}

export default Message
